import { getHaklaiPreCalcInlineErrors } from "../preCalc/logic/haklaiPreCalcValidation";
import { getHaklaiPrisaMaxYears, getHaklaiPrisaMinYears } from "./haklaiPrisaHelpers";
import { HAKLAI_PRISA_MESSAGES } from "./haklaiPrisaTexts";

export const getHaklaiPrisaSectionState = (preCalc = {}) => {
  const preCalcErrors = getHaklaiPreCalcInlineErrors(preCalc);
  if (Object.keys(preCalcErrors).length > 0) {
    return {
      unlocked: false,
      reason: HAKLAI_PRISA_MESSAGES.preCalcRequired,
      blockingSection: "preCalc"
    };
  }

  if (getHaklaiPrisaMaxYears(preCalc) < 1) {
    return {
      unlocked: false,
      reason: HAKLAI_PRISA_MESSAGES.sameSalePurchaseYearUnavailable,
      blockingSection: "preCalc"
    };
  }

  if (getHaklaiPrisaMinYears(preCalc) === 0) {
    return {
      unlocked: false,
      reason: HAKLAI_PRISA_MESSAGES.partialPurchaseInSaleYearUnavailable,
      blockingSection: "preCalc"
    };
  }

  return {
    unlocked: true,
    reason: "",
    blockingSection: ""
  };
};
